import React from "react";
import "./Loader.scss";

const Loader = ({ visible, text = "Loading...", onClose }) => {
  if (!visible) return null;

  return (
    <div className="loader-overlay">
      <div className="loader-box">

        {/* Close Button (Top Right, Big & White) */}
        <button className="loader-close" onClick={onClose}>
          ✕
        </button>

        <div className="loader-spinner"></div>
        <div className="loader-text">{text}</div>
      </div>
    </div>
  );
};

export default Loader;
